$(document).on('turbolinks:load', function () {
  if (!$('body').hasClass('controller-public-hotsites-standings')) return;

  $('.hotsite-standings-filters select').on('change', function () {
    $(this).closest('form').trigger('submit');
  });
});

$(document).on('click', '.hotsite-standings-division-toggle', function () {
  if (!$('body').hasClass('controller-public-hotsites-standings')) return;

  $(this).next('.hotsite-standings-division-matches').toggleClass('d-none');
  $(this).find('i').toggleClass('mdi-chevron-down mdi-chevron-up');
});

$(document).on('ajax:before', '.hotsite-standings-match-toggle', function (event) {
  if (!$('body').hasClass('controller-public-hotsites-standings')) return;

  const $results = $('#standing-' + $(this).data('match-id'));
  if ($results.children().length === 0) {
    $('.generic-loader').removeClass('d-none');
    return;
  }

  event.preventDefault();
  $(this).find('i').toggleClass('mdi-chevron-down mdi-chevron-up');
  $results.toggleClass('d-none');
  return false;
});

$(document).on('ajax:complete ajax:error', '.hotsite-standings-match-toggle', function () {
  $('.generic-loader').addClass('d-none');
});

$(document).on('click', '.controller-public-hotsites-standings .toggle-calculation', function () {
  $(this).parent().find('.hotsite-standings-calculation-body').toggleClass('d-none');
});
